import cn from "classnames";

import InfoIcon from "assets/icons/info.svg?react";

import { CALCULATOR_SCENARIO_VARIANT } from "constants/calculator";

import { Popover } from "shared/ui/components/Popover";
import { Typography } from "shared/ui/components/Typography";

import styles from "./InvestmentGraphic.module.scss";

const InvestmentGraphic = ({
  className,
  infoPopover,
  variant = "default",
  descriptionVariant = "default",
  children,
  title,
  price,
  caption,
  description,
  details,
}: {
  className?: string;
  infoPopover?: React.ReactNode;
  variant?: string;
  descriptionVariant?: string;
  children?: React.ReactNode;
  title?: string;
  price?: string;
  caption?: string;
  description?: React.ReactNode;
  details?: string;
}) => {

  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.top}>
        {title && (
          <Typography
            className={styles.title}
            variant="bodyS"
            weight="semiBold"
          >
            {title}
          </Typography>
        )}

        <div className={styles.topContent}>
          <div className={styles.topInner}>
            {price && (
              <Typography
                className={cn(styles.price, {
                  [styles.pricePositive]:
                    variant === CALCULATOR_SCENARIO_VARIANT.POSITIVE,
                  [styles.priceNegative]:
                    variant === CALCULATOR_SCENARIO_VARIANT.NEGATIVE,
                  [styles.priceNeutral]:
                    variant === CALCULATOR_SCENARIO_VARIANT.NEUTRAL,
                })}
                variant="h5"
                weight="bold"
              >
                {price}
              </Typography>
            )}
            <Typography variant="bodyXS" weight="regular">
              {caption}
            </Typography>
          </div>

          <div className={styles.topRight}>{children}</div>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.bottomInner}>
          <Typography
            variant="bodyXXS"
            weight="semiBold"
            className={cn(styles.price, {
              [styles.pricePositive]:
                descriptionVariant === CALCULATOR_SCENARIO_VARIANT.POSITIVE,
              [styles.priceNegative]:
                descriptionVariant === CALCULATOR_SCENARIO_VARIANT.NEGATIVE,
              [styles.priceNeutral]:
                descriptionVariant === CALCULATOR_SCENARIO_VARIANT.NEUTRAL,
            })}
          >
            {description}
          </Typography>
          <Typography variant="bodyXXS" weight="light">
            {details}
          </Typography>
        </div>
        {!!infoPopover && (
          <Popover
            placement="top"
            triggerType="hover"
            yOffset={15}
            floatingArrowProps={{ width: 17, height: 10, fill: "#fff" }}
            triggerClassName={styles.trigger}
            triggerElement={() => <InfoIcon className={styles.infoIcon} />}
          >
            {infoPopover}
          </Popover>
        )}
      </div>
    </div>
  );
};

export default InvestmentGraphic;
